import(/* webpackMode: "eager" */ "/app/apps/web/src/app/components/page-icons.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["CreatePoll"] */ "/app/apps/web/src/components/create-poll.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["Trans"] */ "/app/apps/web/src/components/trans.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["RelativeDate"] */ "/app/apps/web/src/features/quick-create/components/relative-date.tsx");
;
import(/* webpackMode: "eager" */ "/app/node_modules/.pnpm/next@15.5.25_@babel+core@7.29.7_supports-color@8.1.1__@opentelemetry+api@1.9.1_@playwri_ff0ca25ff55548299e7f812de2c6e158/node_modules/next/dist/client/app-dir/link.js");
;
import(/* webpackMode: "eager" */ "/app/packages/ui/src/button.tsx");
;
import(/* webpackMode: "eager" */ "/app/packages/ui/src/icon.tsx");
